<div class="unit-economics-calculations-title">
  <div class="unit-economics-calculations-title-text">
    {{ data().name || 'Новая' }}
  </div>
  @if (!!data().id && isEditModeActive()) {
    <button
      mat-mini-fab
      class="unit-economics-calculations-title-btn"
      (click)="handleDelete.emit($event)"
    >
      <mat-icon class="unit-economics-calculations-title-btn-icon">
        delete
      </mat-icon>
    </button>
  }
</div>
